import React from 'react'
import ClassNames from 'classnames'
import { default as VARIABLES } from '../../themes/styles/variables'

import Select, { components } from 'react-select'
//https://react-select.com/home
//https://stackoverflow.com/questions/55830799: How to change zIndex in react-select drowpdown

import { SelectStyle } from './styled'

/**
 * Select description
 * - ...
 */

const Option = props => {
  return <components.Option className={props.data.className} {...props} />
}

const customStyles = {
  placeholder: (base, { isDisabled }) => ({
    ...base,
    color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.GRAY_3,
  }),

  singleValue: (base, { isDisabled }) => ({
    ...base,
    color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.GRAY_3,
    outline: 'none',
  }),

  control: (base, { isDisabled }) => ({
    ...base,
    whiteSpace: 'nowrap',
    boxShadow: 'none',
    borderColor: VARIABLES.COLORS.GRAY_2,
    '&:hover': {
      borderColor: VARIABLES.COLORS.GRAY_2,
    },
    backgroundColor: isDisabled ? VARIABLES.COLORS.GRAY_8 : undefined,
    height: '42px',
    '@media only screen and (min-width: 1601px)': {
      ...base['@media only screen and (min-width: 1601px)'],
      minWidth: '110px',
    },
  }),

  indicatorSeparator: base => ({
    ...base,
    width: '0',
  }),
  indicators: (styles, { isDisabled }) => ({
    ...styles,
    display: isDisabled ? 'none' : 'block',
  }),
  dropdownIndicator: (base, { isDisabled, checkPageCompare }) => ({
    ...base,
    display: checkPageCompare === true && 'none',
    color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.BLUE_1,
    '&:hover': {
      color: isDisabled ? VARIABLES.COLORS.GRAY_10 : VARIABLES.COLORS.BLUE_1,
    },
  }),

  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? VARIABLES.COLORS.BLUE_1
        : undefined,
      '&:hover': {
        backgroundColor: isDisabled
          ? VARIABLES.COLORS.GRAY_4
          : isSelected
          ? VARIABLES.COLORS.BLUE_1
          : VARIABLES.COLORS.GRAY_4,
      },
    }
  },
}

export class SelectBox extends React.PureComponent {
  render() {
    const { className, style } = this.props
    return (
      <SelectStyle
        style={style}
        className={ClassNames('select-control', className)}
      >
        <Select
          components={{ Option }}
          //menuPortalTarget={document.body}
          {...this.props}
          styles={customStyles}
          classNamePrefix="select"
          className="test"
        />
      </SelectStyle>
    )
  }
}
